import React from 'react';
import { message } from 'antd';

import PaginationBase from '../../../common/base/PaginationBase';
import dialog from '../../../common/utility/dialog';
import estadoMock from '../../../common/mock/estadoMock';
import global from '../../../common/utility/global';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import { DOMICILIO_FISCAL } from '../../../common/types/tipoEstablecimientoType';
import { RUC } from '../../../common/types/tipoDocumentoType';
import { HABIDO } from '../../../common/types/condicionSunatType';
import { ACTIVO } from '../../../common/types/estadoContribuyenteType';
import { JURIFICA, NATURAL } from '../../../common/types/tipoPersonaType';

import entidadService from '../../../service/administracion/entidadService';
import padronReducidoService from '../../../service/integracion/padronReducidoService';
import tipoPersonaService from '../../../service/administracion/tipoPersonaService';
import tipoDocumentoService from '../../../service/administracion/tipoDocumentoService';
import condicionSunatService from '../../../service/administracion/condicionSunatService';
import estadoContribuyenteService from '../../../service/administracion/estadoContribuyenteService';
import tipoRelacionService from '../../../service/administracion/tipoRelacionService';
import tipoEstablecimientoService from '../../../service/administracion/tipoEstablecimientoService';
import establecimientoService from '../../../service/administracion/establecimientoService';
import ubigeoService from '../../../service/integracion/ubigeoService';
import paisService from '../../../service/administracion/paisService';

import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';
import DetalleFormModal from './DetalleFormModal';
import EstablecimientoFormModal from '../Establecimiento/FormModal';

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingSource: true,
            loadingExcel: false,
            loadingPdf: false,
            loadingPrint: false,
            estados: estadoMock.values,
            tiposPersona: [],
            tiposDocumento: [],
            condicionesSunat: [],
            estadosContribuyente: [],
            tiposEstablecimiento: [],
            tiposRelacion: [],
            vendedores: [],
            departamentos: [],
            provincias: [],
            distritos: [],
            paises: [],
            filter: {
                idTipoPersona: 0,
                idTipoDocumento: 0,
                numeroDocumento: '',
                nombreRazonSocial: '',
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            visibleDetalle: false,
            visibleFormEstablecimiento: false,
            formValues: this.fetchEmptyFormValues(),
            formValuesDetalle: this.fetchEmptyFormValuesDetalle(),
            formValuesEstablecimiento: this.fetchEmptyFormValuesEstablecimiento()
        }
    }

    handleClearFilters = () => {
        var filter = {
            idTipoPersona: 0,
            idTipoDocumento: 0,
            numeroDocumento: '',
            nombreRazonSocial: '',
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = await entidadService.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Entidad.xlsx");
    };

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await entidadService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Entidad.pdf");
    }

    handlePrint = async () => {
        this.setState({ loadingPrint: true });
        var response = await entidadService.pdf(this.state.filter);
        this.setState({ loadingPrint: false });
        if (response !== undefined) {
            var file = window.URL.createObjectURL(response.data);
            var win = window.open(file, '_blank');
            win.focus();
        }
    }

    handleDeleteActive = (values) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.flag)
                response = await entidadService.eliminar(values);
            else
                response = await entidadService.activar(values);

            if (response.status === 200) {
                message.success('Proceso realizado correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    /******************** FORM MODAL *****************/

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            idTipoPersona: 0,
            idTipoDocumento: RUC.ID,
            numeroDocumento: '',
            razonSocial: '',
            nombre: '',
            apellidoPaterno: '',
            apellidoMaterno: '',
            correo: '',
            idEstadoContribuyente: ACTIVO,
            idCondicionSunat: HABIDO,
            idTipoRelacion: 0,
            //idVendedor: 0,
            nombreTipoEstablecimiento: '',
            telefono: '',
            idDepartamento: 0,
            idProvincia: 0,
            idUbigeo: 0,
            direccion: '',
            /******************/
            searchLoading: false,
            flagPersonaJuridica: true,
            flagPersonaNatural: false,
            tiposPersona: [],
            tiposDocumento: [],
            condicionesSunat: [],
            estadosContribuyente: [],
            tiposEstablecimiento: [],
            tiposRelacion: [],
            vendedores: [],
            departamentos: [],
            provincias: [],
            distritos: [],
            paises: [],
        }
    };

    fetchEmptyFormValuesDetalle = () => {
        return {
            idEntidad: 0,
            nombre: '',
            detalle: []
        }
    };

    fetchEmptyFormValuesEstablecimiento = () => {
        return {
            id: 0,
            nombre: '',
            idTipoEstablecimiento: 0,
            idDepartamento: 0,
            idProvincia: 0,
            idUbigeo: 0,
            direccion: '',
            telefono: '',
            tipoEstablecimientos: [],
            departamentos: [],
            provincias: [],
            distritos: []
        }
    };

    handleNew = () => {
        var formValues = this.fetchEmptyFormValues();
        var tipoEstablecimientoFiltered = this.state.tiposEstablecimiento.filter(m => m.id === DOMICILIO_FISCAL.ID);
        var tiposPersonaFiltered = this.state.tiposPersona.filter(m => m.codigo === JURIFICA.CODIGO);
        formValues.paises = this.state.paises;
        formValues.tiposPersona = this.state.tiposPersona;
        formValues.tiposDocumento = this.state.tiposDocumento;
        formValues.condicionesSunat = this.state.condicionesSunat;
        formValues.estadosContribuyente = this.state.estadosContribuyente;
        formValues.tiposRelacion = this.state.tiposRelacion;
        formValues.departamentos = this.state.departamentos;
        formValues.idTipoPersona = tiposPersonaFiltered.length === 0 ? 0 : tiposPersonaFiltered[0].id
        formValues.nombreTipoEstablecimiento = tipoEstablecimientoFiltered.length === 0 ? '' : tipoEstablecimientoFiltered[0].nombre;

        this.setState({ visible: true, formValues });
    };

    handleViewDetalle = async (row) => {
        var formValuesDetalle = this.fetchEmptyFormValuesDetalle();
        var detalle = await establecimientoService.listarTodoPorIdEntidad(row.id);

        formValuesDetalle.idEntidad = row.id;
        formValuesDetalle.detalle = detalle;

        this.setState({
            visibleDetalle: true,
            detalle,
            formValuesDetalle,
        });
    };

    handleNewEstablecimiento = () => {
        var formValuesEstablecimiento = this.fetchEmptyFormValuesEstablecimiento();
        formValuesEstablecimiento.tipoEstablecimientos = this.state.tiposEstablecimiento.filter(m => { return m.codigoSunat !== DOMICILIO_FISCAL.CODIGO });
        formValuesEstablecimiento.departamentos = this.state.departamentos;
        this.setState({ visibleFormEstablecimiento: true, formValuesEstablecimiento });
    };

    hanleBuscarEstablecimiento = async (value) => {
        const detalleFiltered = this.state.detalle.filter(m => ['', null, undefined].includes(value) ||
            global.formatSearch(m.nombre).match(global.formatSearch(value)));

        this.setState({
            formValuesDetalle: {
                ...this.state.formValuesDetalle,
                detalle: detalleFiltered
            }
        });
    };

    handleBuscarPadronReducido = async (idTipoDocumento, numeroDocumento, form) => {
        this.setState({ formValues: { ...this.state.formValues, searchLoading: true } });
        const response = await padronReducidoService.entidad({ idTipoDocumento, numeroDocumento });

        if (response.status === 200) {
            const provincias = response.data.idUbigeo !== 0 ? await ubigeoService.provincias(response.data.idDepartamento) : [];
            const distritos = response.data.idUbigeo !== 0 ?  await ubigeoService.distritos(response.data.idProvincia) : [];
        
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    searchLoading: false,
                    provincias,
                    distritos
                }
            }, () => {
                form.setFieldsValue({
                    razonSocial: response.data.razonSocial,
                    nombre: response.data.nombre,
                    apellidoMaterno: response.data.apellidoMaterno,
                    apellidoPaterno: response.data.apellidoPaterno,
                    idCondicionSunat: { key: response.data.idCondicionSunat },
                    idEstadoContribuyente: { key: response.data.idEstadoContribuyente },
                    idDepartamento: { key: response.data.idDepartamento !== 0 ? response.data.idDepartamento : undefined},
                    idProvincia: { key: response.data.idProvincia !== 0 ? response.data.idProvincia : undefined},
                    idUbigeo: { key: response.data.idUbigeo !== 0 ? response.data.idUbigeo : undefined},
                    direccion: response.data.direccion,
                });
            });
        }
        else {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    searchLoading: false
                }
            });
        }
    };

    handleEdit = async (values) => {
        const response = await entidadService.obtenerPorId(values.id);

        if (response !== undefined) {
            response.flagPersonaJuridica = response.codigoTipoPersona === JURIFICA.CODIGO ? true : false;
            response.flagPersonaNatural = response.codigoTipoPersona === NATURAL.CODIGO ? true : false;
            response.tiposPersona = this.state.tiposPersona;
            response.tiposDocumento = this.state.tiposDocumento;
            response.condicionesSunat = this.state.condicionesSunat;
            response.estadosContribuyente = this.state.estadosContribuyente;
            response.tiposRelacion = this.state.tiposRelacion;
            response.vendedores = this.state.vendedores;
            response.departamentos = this.state.departamentos;
            response.paises = this.state.paises;
            response.provincias = await ubigeoService.provincias(response.idDepartamento);
            response.distritos = await ubigeoService.distritos(response.idProvincia);
            this.setState({ visible: true, formValues: response });
        }
    };

    handleEditEstablecimiento = async (values) => {
        const response = await establecimientoService.obtenerPorId(values.id);
        if (response !== undefined) {
            response.tipoEstablecimientos = this.state.tiposEstablecimiento.filter(m => { return m.codigoSunat !== DOMICILIO_FISCAL.CODIGO });
            response.departamentos = this.state.departamentos;
            response.provincias = await ubigeoService.provincias(response.idDepartamento);
            response.distritos = await ubigeoService.distritos(response.idProvincia);
            this.setState({ visibleFormEstablecimiento: true, formValuesEstablecimiento: response });
        }
    };

    handleChangeForm = async (property, value) => {
        if (property === "idDepartamento") {
            const provincias = await ubigeoService.provincias(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    provincias: provincias ? provincias : [],
                    distritos: []
                }
            });
        }

        if (property === "idProvincia") {
            const distritos = await ubigeoService.distritos(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    distritos: distritos ? distritos : []
                }
            });
        }

        if (property === "clear") {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    provincias: [],
                    distritos: []
                }
            });
        }
    };

    handleChangeFormEstablecimiento = async (property, value) => {
        if (property === "idDepartamento") {
            const provincias = await ubigeoService.provincias(value);
            this.setState({
                formValuesEstablecimiento: {
                    ...this.state.formValuesEstablecimiento,
                    provincias: provincias ? provincias : [],
                    distritos: []
                }
            });
        }

        if (property === "idProvincia") {
            const distritos = await ubigeoService.distritos(value);
            this.setState({
                formValuesEstablecimiento: {
                    ...this.state.formValuesEstablecimiento,
                    distritos: distritos ? distritos : []
                }
            });
        }
    };

    handleSave = (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;

            if (values.id === 0)
                response = await entidadService.registrar(values);
            else
                response = await entidadService.modificar(values);

            if (response.status === 200) {
                form.resetFields();
                this.setState({ visible: false });
                message.success((values.id === 0 ? 'Registrado' : 'Modificado') + ' correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleSaveEstablecimiento = (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            values.idEntidad = this.state.formValuesDetalle.idEntidad;
            var response;
            if (values.id === 0)
                response = await establecimientoService.registrar(values);
            else
                response = await establecimientoService.modificar(values);

            if (response.status === 200) {
                var detalle = await establecimientoService.listarTodoPorIdEntidad(values.idEntidad);

                form.resetFields();
                this.setState({
                    detalle,
                    visibleFormEstablecimiento: false
                }, () => this.hanleBuscarEstablecimiento(''));

                message.success((values.id === 0 ? 'Registrado' : 'Modificado') + ' correctamente.');
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleDeleteActiveEstablecimiento = (values) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.flag)
                response = await establecimientoService.eliminar(values);
            else
                response = await establecimientoService.activar(values);

            if (response.status === 200) {
                var detalle = await establecimientoService.listarTodoPorIdEntidad(this.state.formValuesDetalle.idEntidad);
                this.setState({ detalle }, () => this.hanleBuscarEstablecimiento(''));
                message.success('Proceso realizado correctamente.');
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    async componentDidMount() {
        this._initPagination(this.state.filter, entidadService.paginacion);

        const tiposPersona = await tipoPersonaService.listar();
        const tiposDocumento = await tipoDocumentoService.listarExcluirPlaca();
        const condicionesSunat = await condicionSunatService.listar();
        const estadosContribuyente = await estadoContribuyenteService.listar();
        const departamentos = await ubigeoService.departamentos();
        const tiposRelacion = await tipoRelacionService.listar();
        const tiposEstablecimiento = await tipoEstablecimientoService.listar();
        const paises = await paisService.listar();
        this.setState({
            loadingSource: false,
            tiposPersona: tiposPersona ? tiposPersona : [],
            tiposDocumento: tiposDocumento ? tiposDocumento : [],
            condicionesSunat: condicionesSunat ? condicionesSunat : [],
            estadosContribuyente: estadosContribuyente ? estadosContribuyente : [],
            tiposRelacion: tiposRelacion ? tiposRelacion : [],
            departamentos: departamentos ? departamentos : [],
            tiposEstablecimiento: tiposEstablecimiento ? tiposEstablecimiento : [],
            paises: paises ? paises : []
        });
    };

    render() {
        return (
            <div>
                <Header
                    title="Entidad"
                    onNew={this.handleNew}
                    loadingNew={this.state.loadingSource}
                    onSearch={() => this._handlePagination({ ...this.state.filter, ...FILTER })}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    tiposPersona={this.state.tiposPersona}
                    tiposDocumento={this.state.tiposDocumento}
                    estados={this.state.estados}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingEdit={this.state.loadingSource}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingPrint={this.state.loadingPrint}
                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    onPrint={this.handlePrint}
                    onEdit={this.handleEdit}
                    onViewDetail={this.handleViewDetalle}
                    onDeleteActive={this.handleDeleteActive}
                    onChange={this._handleChangePagination}
                />
                <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onChange={this.handleChangeForm}
                    onBuscarPadronReducido={this.handleBuscarPadronReducido}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                />
                <DetalleFormModal
                    visible={this.state.visibleDetalle}
                    formValues={this.state.formValuesDetalle}
                    onSearch={this.hanleBuscarEstablecimiento}
                    onClose={() => this.setState({ visibleDetalle: false })}
                    onNew={this.handleNewEstablecimiento}
                    onEdit={this.handleEditEstablecimiento}
                    onDeleteActive={this.handleDeleteActiveEstablecimiento}
                />
                <EstablecimientoFormModal
                    visible={this.state.visibleFormEstablecimiento}
                    formValues={this.state.formValuesEstablecimiento}
                    onChange={this.handleChangeFormEstablecimiento}
                    onClose={() => this.setState({ visibleFormEstablecimiento: false })}
                    onSave={this.handleSaveEstablecimiento}
                />
            </div>
        )
    }
}